import React from 'react';
import Icon from '../../components/Icon';
import { BotBadge, EmptyState } from '../../components/ui';
import { initial, isOnline } from '../../lib/format';

export default function BrowseGrid({ people, onOpenProfile, onOpenChat, emptyText }) {
  if (people.length === 0) {
    return <EmptyState icon="search" title="Nobody here" text={emptyText} />;
  }

  return (
    <div className="people-grid">
      {people.map((person) => (
        <div className="person-card" key={person._id}>
          <button
            type="button"
            className="person-card-media"
            onClick={() => onOpenProfile(person)}
            style={{ border: 'none', padding: 0, cursor: 'pointer', width: '100%' }}
            aria-label={`View ${person.username}'s profile`}
          >
            {person.profileImage ? (
              <img src={person.profileImage} alt="" />
            ) : (
              <div className="person-card-fallback">{initial(person.username)}</div>
            )}
            {person.isBot && (
              <span className="person-card-badge">
                <BotBadge />
              </span>
            )}
            {isOnline(person.lastSeen) && <span className="person-card-online" title="Active now" />}
          </button>
          <div className="person-card-body">
            <div className="person-card-name">{person.username}</div>
            <p className="person-card-bio">{person.bio || 'No bio yet'}</p>
            <div className="person-card-actions">
              <button type="button" className="btn btn-secondary btn-sm btn-block" onClick={() => onOpenChat(person)}>
                <Icon name="chat" size={15} />
                Message
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
